export default class DrugListing {
    constructor() {
        console.log('%c👍🏼 DrugListing', 'color: yellow');
        this.drugListing = document.querySelector('.drug-listing');
        
    }
    init() {

       const letterButtons = this.drugListing.querySelectorAll('.drug-listing .letter-button'); 

       const letterHeadings = this.drugListing.querySelectorAll('.drug-listing__letter');
       const accordions = this.drugListing.querySelectorAll('.accordion');
       const searchInput = this.drugListing.querySelector('#drug-listing-search');
       const noResults = this.drugListing.querySelector('.drug-listing__no-results');


       const unshowLetters = () => {
        
        letterHeadings.forEach((letterHeading) => {
            letterHeading.classList.remove('show');
            letterHeading.nextElementSibling.classList.remove('show');
        })
       };

       const showLetters = (letter) => {
       
              letterHeadings.forEach((letterHeading) => {
                if (letterHeading.innerText === letter) {
                     letterHeading.classList.add('show');
                     let accordion = letterHeading.nextElementSibling;
                     accordion.classList.add('show');
                     accordion.classList.remove('hide');

                     let accordionItems = accordion.querySelectorAll('.accordion-item');
                    accordionItems.forEach((accordionItem) => {
                        accordionItem.classList.add('show');
                        accordionItem.classList.remove('hide');
                    });
                }
              });
       };

        letterButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                searchInput.value = '';
                console.log('button clicked');
                unshowLetters();
                let letter = event.target.innerText;
                showLetters(letter); 
            });
        });
 
        
        const drugListingTitles = this.drugListing.querySelectorAll('.drug-listing__letter');
        searchInput.addEventListener('keyup', function(event){
            noResults.classList.remove('show');
            let searchString = event.target.value;
            unshowLetters();
            if(searchString.length >= 2) {
            
                drugListingTitles.forEach((term) => {
                    
                    let foundMatchForLetter = false;
                    let accordion = term.nextElementSibling; 
                    let accordionItem = accordion.querySelector('.accordion-item');

                    while (accordionItem && accordionItem.classList && accordionItem.classList.contains('accordion-item')) {
                        let title = accordionItem.querySelector('h3').innerText;
                        let definition = accordionItem.querySelector('.drug-listing__definition').innerText;
                        if (title.toLowerCase().includes(searchString.toLowerCase()) || definition.toLowerCase().includes(searchString.toLowerCase())){
                            foundMatchForLetter = true;
                            accordion.classList.add('show');
                            accordionItem.classList.add('show');
                            accordionItem.classList.remove('hide');
                            term.classList.add('show');
                        } else {
                            accordionItem.classList.remove('show');
                            accordionItem.classList.add('hide');
                        }

                        if (!foundMatchForLetter) {
                            noResults.classList.add('show');
                        } else {
                            noResults.classList.remove('show');
                        }

                        accordionItem = accordionItem.nextElementSibling;
                    }
                });
            }
        });


        const currentAnchor = window.location.hash;
        if(currentAnchor) {
            const anchorMatch = this.drugListing.querySelector(currentAnchor);
            if (anchorMatch) {
                let letter = currentAnchor[1].toUpperCase();
                unshowLetters();
                showLetters(letter); 
                scrollTo(0, anchorMatch.offsetTop - 100)
            }
        }
    }
}